import { render, staticRenderFns } from "./HomeDigitalStore.vue?vue&type=template&id=554278d0&"
import script from "./HomeDigitalStore.vue?vue&type=script&lang=js&"
export * from "./HomeDigitalStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports